import React from "react";
import { Tag, Tooltip } from "antd";
import { Tariff } from "../utils/types";
import {
  getTariffStatus,
  getTariffStatusColor,
  getTariffStatusLabel,
} from "../utils/tariffHelpers";

interface StatusTagProps {
  tariff: Tariff;
  showTooltip?: boolean;
}

const StatusTag: React.FC<StatusTagProps> = ({
  tariff,
  showTooltip = false,
}) => {
  const status = getTariffStatus(tariff);
  const color = getTariffStatusColor(status);
  const label = getTariffStatusLabel(status);

  const tag = <Tag color={color}>{label}</Tag>;

  if (!showTooltip) {
    return tag;
  }

  let tooltipContent = "";
  const today = new Date();
  const endDate = tariff.to ? new Date(tariff.to) : null;

  switch (status) {
    case "incomplete":
      tooltipContent =
        "This tariff is missing essential information and needs to be completed.";
      break;
    case "expired":
      tooltipContent = `This tariff expired on ${endDate?.toLocaleDateString()}.`;
      break;
    case "future":
      tooltipContent = `This tariff will become active on ${
        tariff.from
          ? new Date(tariff.from).toLocaleDateString()
          : "unknown date"
      }.`;
      break;
    case "expiring":
      if (endDate) {
        const daysLeft = Math.ceil(
          (endDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
        );
        tooltipContent = `This tariff will expire in ${daysLeft} days.`;
      }
      break;
    case "active":
      tooltipContent = "This tariff is currently active.";
      break;
  }

  return <Tooltip title={tooltipContent}>{tag}</Tooltip>;
};

export default StatusTag;
